<template>
  <div class="m-0 pl-5">
    <div class="card w-full">
      <Tabs
        :value="activeTabIndex"
        class="w-full"
        @update:value="onTabChange"
      >
        <TabList>
          <Tab
            v-for="tab in items"
            :key="tab.label"
            :value="tab.route"
          >
            <router-link
              v-if="tab.route"
              v-slot="{ href, navigate }"
              :to="tab.route"
              custom
            >
              <a
                v-ripple
                :href="href"
                class="flex items-center gap-2 text-inherit"
                @click="navigate"
              >
                <i :class="tab.icon" />
                <span>{{ tab.label }}</span>
              </a>
            </router-link>
          </Tab>
        </TabList>
      </Tabs>
      <div class="py-4">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

// Define the tab items with icons (Timeline first = default)
const items = ref([
    {
        route: '/projects/timeline',
        label: 'Timeline',
        icon: 'pi pi-calendar'
    },
    {
        route: '/projects/list',
        label: 'Projects',
        icon: 'pi pi-list'
    },
    {
        route: '/projects/quick-quotes',
        label: 'Quick Quotes',
        icon: 'pi pi-file'
    }
]);

// Compute active tab index based on current route
const activeTabIndex = computed(() => {
    const path = route.path;
    return items.value.findIndex(item => item.route === path);
});

// Handle tab changes
const onTabChange = (event) => {
    const selectedTab = items.value[event.index];
    if (selectedTab && selectedTab.route !== route.path) {
        router.push(selectedTab.route);
    }
};

// Watch for route changes to update active tab
watch(
    () => route.path,
    (newPath) => {
        const index = items.value.findIndex(item => item.route === newPath);
        if (index !== -1) {
            activeTabIndex.value = index;
        }
    },
    { immediate: true }
);
</script>

<style scoped>
/* Component-specific styles can go here if needed */
</style> 